import { combineReducers } from 'redux'

import settings from './settings'
import disciplines from './disciplines'

import { reducer as pages } from './modules/Page'
import { reducer as resources } from './modules/Resources'
import { reducer as supporters } from './modules/Supporters'
import { reducer as letters } from './modules/Letter'
import { reducer as pledges } from './modules/Pledge'
import { reducer as pledgespage } from './modules/Pledges'

const reducer = combineReducers({
    settings,
    resources,
    supporters,
    letters,
    pages,
    pledges,
    pledgespage,
    disciplines
})

export default reducer



// WEBPACK FOOTER //
// ./client/reducer.js